export default __webpack_public_path__ + "static/media/icons8-download-thin-96.da6fad55.svg";